export default __webpack_public_path__ + "static/media/turkey.1a77a0d6.jpeg";